import * as d3 from "d3";
import {
    DEFAULT_AXIS_FONT_SIZE,
    DEFAULT_AXIS_LABEL_FONT_SIZE,
    axisTextDim1,
    colonAnnotation, createTooltip,
    fw_progressive_1way,
    inrFormatterV2,
    make_y_gridlines,
    responsivefy,
    XaxisAttribute
} from '../functions'

export default function (chart, divId, vizName,resData, filterParam, gridflag) {
    const defaultSize = true
    const defaultChartLayout = {
        width: 1000,
        height: 300,
        margin: { top: 30, right: 100, bottom: 150, left: 100 }
    }
    const chartWidth = defaultSize ? defaultChartLayout.width : chart.width
    const chartHeight = defaultSize ? defaultChartLayout.height : chart.height
    const chartMargin = defaultSize ? defaultChartLayout.margin : chart.margin
    /*Imp Note:
        1. Graph col must be end with '#' (like: DevLastWkRev%#).
        2. which metric will display the graph same number to be put the graph also.
        ie. if we want to print the graph metric3, so graph also be graph3.
    */
    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName;
    // console.log("table bar", url)
    // axios.post(url, filterParam).then(res => {
        let data = resData
        // Filter null and undefined values from the data
        //let filteredData = Object.entries(data[0]).reduce((a,[k,v]) => (v == null ? a: (a[k]=v, a) ), {})

        // Setup the scale for the values for display, use abs max as max value
        var titleMap = chart.reportHeaderColumnDp;
        console.log("titleMap:", titleMap)
        // get the keys from filtered data which filtered null, undefined columns

        var dataTitlesOrg = d3.values(titleMap)
        var dataTitles = dataTitlesOrg.filter(function (item) {
            return !item.startsWith('graph')
        })
        /* to make soting fun work properly based on data dim names,
        create a title mapping between dp names and backend dim names */
        var titles = d3.keys(titleMap)
        var sortAscending = true;

        //Table reports ploting to times need to revisit
        d3.select(divId).select("table").remove();
        //  d3.select(divId, "table").remove();
        var table = d3.select(divId).append("table").style("width", "100%");

        // Create table header
        var headers = table.append('thead')
            .append('tr')
            .selectAll('th')
            .data(titles)
            .enter()
            .append('th')
            .attr("class", 'tbc-header')
            .style("background", "#333")
            .text(function (d) {
                return d
            })
            .style("text-align", "center")
            .style("color", "#fff")
            .on('click', function (d) {
                headers.attr('class', 'tbc-header')
                if (sortAscending) {
                    let graphMetric = titleMap[d]
                    if (d.endsWith('#')) {
                        graphMetric = titleMap[d].replace('graph', 'metric')
                    }
                    tr.sort(function (a, b) {
                        return b[graphMetric] < a[graphMetric] ? 1 : -1;
                    });
                    sortAscending = false;
                    this.className = 'tbc-aes';
                    console.log("sort if asc")
                } else {
                    let graphMetric = titleMap[d]
                    if (d.endsWith('#')) {
                        graphMetric = titleMap[d].replace('graph', 'metric')
                    }
                    tr.sort(function (a, b) {
                        return b[graphMetric] > a[graphMetric] ? 1 : -1;
                    });
                    sortAscending = true;
                    this.className = 'tbc-des';
                    console.log("sort else desc")
                }
            });
        // Create a table with rows and bind a data row to each table row
        var tr = table.selectAll('tr.g').data(data).enter().append('tr');
        //selectAll selects the already available tr element so it skips the data first row
        //https://stackoverflow.com/questions/19182775/d3-data-skipping-the-first-row-of-data
        tr.selectAll('td')
            .data(function (d) {
                return dataTitles.map(function (k) {
                    return {'value': d[k], 'name': k};
                });
            })
            .enter()
            .append('td')
            .attr("class", "reptd")
            .attr('data-th', (d) => {
                return d.name;
            })
            // .text((d) =>{ return inrFormatter(d.value) })
            .text((d) => {
                return typeof d.value != 'number' ? d.value : inrFormatterV2(d.value,chart.data.menuId)
            })
            .style("text-align", (d) => {
                return d.name.startsWith('metric') ? 'right' : 'left'
            })
            .style("color", (d) => {
                if (d.name.startsWith('metric')) {
                    return d.value >= 0 ? chart.vizSpecific4 : chart.vizSpecific5
                }
            });

        for (var key in titleMap) {
            if (titleMap[key].startsWith('graph')) {
                var val = titleMap[key];
                var valMetric = val.replace('graph', 'metric')
                var graph = tr.append("td").attr("class", "tbc-" + val).attr("width", 2 * chartWidth)
                graph.append("body").attr("class", "container").append("body").attr("class", "negative" + val.replace('graph', ''))
                graph.append("body").attr("class", "container").append("body").attr("class", "positive" + val.replace('graph', ''))
                var x1Scale = d3.scaleLinear()
                    .domain([0, d3.max(data, (d) => {
                        return Math.abs(d[valMetric]);
                    })])
                    .range(["0", "100%"]);
                tr.select("body.negative" + val.replace('graph', ''))
                    .style("width", "0%")
                    .transition()
                    .duration(500)
                    .style("width", (d) => {
                        return d[valMetric] > 0 ? "0%" : x1Scale(Math.abs(d[valMetric]));
                    })
                    .style("float", "right")
                    .style("background-color", chart.vizSpecific5);

                tr.select("body.positive" + val.replace('graph', ''))
                    .style("width", "0%")
                    .transition()
                    .duration(500)
                    .style("width", (d) => {
                        return d[valMetric] > 0 ? x1Scale(d[valMetric]) : "0%";
                    })
                    .style("background-color", chart.vizSpecific4);
            }
        }

        var size = defaultSize ? DEFAULT_AXIS_FONT_SIZE : chart.axisFontSize
        var fontSize = size + "px"
        var fontColor = chart.axisFontColor
        var axisLabelFontSize = (defaultSize ? DEFAULT_AXIS_LABEL_FONT_SIZE : chart.axisLabelFontSize) + "px"
        //var tempVar = chart.tempVar

        console.log("Chart vizName called:", vizName)


        // load the data

        data.forEach(function (d) {
            d.metric1 = +d.metric1
        });

        //  var width2=data.length*chart.vizSpecific2 >chart.width ? chart.width : data.length*chart.vizSpecific2
        // set the ranges
        var x1 = d3.scaleBand().rangeRound([0, chartWidth]).padding(0.1);
        var y2Scale = Math.max(Math.abs(d3.min(data, (d) => {
            d.metric1
        })), Math.abs(d3.max(data, (d) => {
            d.metric1
        })));
        var y1Scale = d3.scaleLinear().domain([-y2Scale, y2Scale]).rangeRound([chartHeight, 0]).nice();

        // define the axis
        var x1AxisLabel = d3.axisBottom().scale(x1);
        var y1AxisLabel = d3.axisLeft().scale(y1Scale).tickFormat(function (d){return inrFormatterV2(d,chart.data.menuId)});

        var metric1ColorScale = d3.scaleOrdinal().range(fw_progressive_1way);


        const tooltip = createTooltip(divId);

        // add the SVG element
        var svg = d3.select(divId).select("svg").remove();
        svg = d3.select(divId)
            .append("svg")
            .attr("width", chartWidth + chartMargin.left + chartMargin.right)
            .attr("height", chartHeight + chartMargin.bottom +  chartMargin.top)
            .call(responsivefy)
            .append("g")
            .attr("transform", "translate(" + chartMargin.left + "," + chartMargin.top + ")");

        //Calling tooltip
        // svg.call(tip1);

        // scale range of the data
        x1.domain(data.map((d) => {
            return d.dim1_name
        }));
        y1Scale.domain([0, Math.max(0, d3.max(data, d => d.metric1))]);

        // add axis
        svg.append("g")
            .attr("class", "x axis")
            .attr("transform", "translate(0," + chartHeight + ")")
            .call(x1AxisLabel)
            .selectAll("text")
            //.attr("class","axisL20")
            .style('font-size', fontSize)
            .style("text-anchor", "start")
            .attr("dx", XaxisAttribute)
            .attr("dy", "-.55em")
            .attr("transform", "rotate(-50)")
            .text(axisTextDim1);

        svg.append('text')
            .attr('x', (chartWidth / 2))
            .attr('y', chartHeight + chartMargin.bottom - 50)
            //.style('fill', 'blue')
            .style("text-anchor", "middle")
            .style('fill', fontColor)
            .style('font-size', axisLabelFontSize)
            .text(chart.x1AxisDisplayName)

        svg.append("g")
            .attr("class", "y axis")
            .call(y1AxisLabel)
            .style("font-size", fontSize)

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', -chartMargin.left + 5 )
            .attr('x', -chartHeight/2)
            .attr("dy", ".71em")
            .style("text-anchor", "middle")
            .style('fill', fontColor)
            .style('font-size', axisLabelFontSize)
            .text(chart.y1AxisDisplayName)

        //Add value top of the bar
        svg.selectAll('text.bar')
            .data(data)
            .enter()
            .append('text')
            .attr('class', 'bar')
            .attr('text-anchor', 'middle')
            .attr('x', (d) => {
                return x1(d.dim1_name) + x1.bandwidth() / 2
            })
            .attr('y', (d) => {
                return d.metric1 < 0 ? (y1Scale(d.metric1) + 25) : (y1Scale(d.metric1) - 5)
            })
            .text((d) => {
                return inrFormatterV2(d.metric1,chart.data.menuId)
            })
            .attr('fill', 'black')
            .style('font-size', fontSize)

        if (gridflag == true) {
            // add the X gridlines
            /*  svg.append("g")
                          .attr("class", "grid")
                          .attr("transform", "translate(0," + chart.height + ")")
                          .call(make_x_gridlines(x1Scale)
                              .tickSize(-chart.height)
                              .tickFormat("") )*/

            // add the Y gridlines
            svg.append("g")
                .attr("class", "grid")
                .call(make_y_gridlines(y1Scale)
                    .tickSize(-chartWidth)
                    .tickFormat(""))
        }

        // Add bar chart
        svg.selectAll("bar")
            .data(data)
            .enter()
            .append("rect")
            .attr("class", (d) => {
                return "bar bar--" + (d.metric1 < 0 ? "bar" : "-bar")
            })
            .attr("x", (d) => {
                return x1(d.dim1_name)
            })
            .attr("width", x1.bandwidth())
            .attr("y", function (d) {
                return y1Scale(Math.max(0, d.metric1))
            })
            .style("fill", (d) => {
                return metric1ColorScale(d.dim1_name)
            })
            .attr("height", (d) => {
                return Math.abs(y1Scale(d.metric1) - y1Scale(0))
            })
            .on("mouseover", function(d) {
                tooltip.onMouseOver(d, this, function(d) {
                    // Tooltip content callback
                    return d.dim1_name + colonAnnotation + inrFormatterV2(d.metric1,chart.data.menuId)
                });  // Pass the event for positioning
            })
            .on('mousemove', function(event) {
                tooltip.onMouseMove(event);  // Update tooltip position on mouse move
            })
            .on("mouseout", function() {
                // Hide the tooltip on mouse out
                tooltip.onMouseLeave();
            });
    // })
}
